module.exports = __webpack_public_path__ + "static/expenseReport2-872599275caf04ebacc2f547e06e4d9d.png";